<div class="toast-container" [ngClass]="typeClass">
  <div class="toast-content">
    <mat-icon class="toast-icon">{{ iconName }}</mat-icon>
    <div class="toast-message">
      {{ data.message }}
    </div>
  </div>

  <div class="toast-actions" *ngIf="data.actions?.length">
    <button mat-button type="button" *ngFor="let action of data.actions; trackBy: trackByLabel"
      [color]="action.color || undefined" (click)="onActionClick(action)">
      <span class="toast-action-label" [style.color]="!action.color ? '#ffffff' : ''">{{ action.label }}</span>
    </button>
  </div>

  <button *ngIf="data.showCloseButton" mat-icon-button type="button" class="toast-close-btn" aria-label="Close"
    (click)="onClose()">
    <mat-icon>close</mat-icon>
  </button>
</div>